export type MappingKey = string | number | boolean;

/** For user mapping, a string formatted as a URL. */
export type MappingUserKey = string;
